export function isPromise(obj: unknown) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj['then'] === 'function';
}

export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
